<template>
    <div class="assetsPage">
        <Header ref="header" :title="title" :titleRight="titleRight" @backPage="onBack" @submit="details"></Header>
        <div class="assetsEchart bgFFFFFF mbot20">
            <span class="totalBalance f48"><i class="f32">¥ </i>{{ assetsUserInfo.totalBalance | NumFormat}}</span>
            <v-chart :options="options" :autoresize="true" />
        </div>
        <div class="assetsList bgFFFFFF mbot48">
            <ul class="assetsUl">
                <li class="assetsItem">
                    <span class="itemText f28"><i class="itemIcon grayIcon"></i><span>冻结资金</span></span>
                    <span class="itemValue f32">¥ {{ assetsUserInfo.frozenBalance | NumFormat}}</span>
                </li>
                <li class="assetsItem">
                    <span class="itemText f28"><i class="itemIcon orgenIcon"></i><span>可用金额</span></span>
                    <span class="itemValue f32">¥ {{ assetsUserInfo.availableBalance | NumFormat}}</span>
                </li>
            </ul>
        </div>
        <div class="buttonBox">
            <div class="buttom bgFF7A45 f28" @click="onPayMoney">充值</div>
            <div class="buttom colFF7A45 f28" @click="withDraw">提现</div>
        </div>
    </div>
</template>

<script>
import Header from '../../../common/header'
import { Dialog } from 'vant'
import { mapState, mapGetters, mapActions } from 'vuex'
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/pie'
import 'echarts/lib/component/title'
import 'echarts/lib/component/legend'

export default {
    name: 'assets',
    components: {
        Header,
        'v-chart': ECharts
    },
    data () {
        return {
            title: '我的钱包',
            titleRight: '账单',
            hasBankcard: false, // 判断名下是否有卡，用来判断是否去绑卡
            userInfo: '',
            userType: ''
        }
    },
    computed: {
        ...mapState({
            getRealut: state => state.b2b.walletState
        }),
        ...mapGetters(['assetsUserInfo', 'bankcardWithdrawList']),
        options: function () {
            return {
                title: {
                    text: '总资产'
                },
                color: ['#FF7A45', '#E8E8EA'],
                label: {
                    normal: {
                        show: false,
                        position: 'center'
                    },
                    emphasis: {
                        show: true,
                        textStyle: {
                            fontSize: '30',
                            fontWeight: 'bold'
                        }
                    }
                },
                series: [
                    {
                        name: '访问来源',
                        type: 'pie',
                        center: ['50%', '55%'],
                        radius: ['65%', '80%'],
                        data: [
                            { value: this.assetsUserInfo.availableBalance, name: '可用金额' },
                            { value: this.assetsUserInfo.frozenBalance, name: '冻结资金' }
                        ],
                        label: {
                            normal: {
                                show: true,
                                position: 'outside',
                                formatter: '{d} %',
                                color: '#999999'
                            }
                        },
                        labelLine: {
                            length: 5,
                            length2: 15
                        }
                    }
                ]
            }
        }
    },
    methods: {
        ...mapActions(['setBuried', 'getAssetsUserInfoAct', 'getBankcardWithdrawListAct']),
        onBack () {
            this.$router.replace({ path: '/b2b/order/index' })
        },
        details () {
            this.$router.push({ path: '/b2b/wallet/myWallet/walletDetails' })
        },
        gotoBankList () {
            localStorage.setItem('gotoBankList', this.$router.history.current.fullPath)
            localStorage.setItem('bankUrl', this.$router.history.current.fullPath)
            this.$router.push({ path: '/b2b/order/myBank' })
        },
        gotopUps () {
            localStorage.setItem('topUpsBack', this.$router.history.current.fullPath)
            this.$router.push({
                path: '/b2b/wallet/topUps',
                query: {
                    userType: this.userType,
                    bindSource: 2
                } })
        },
        onPayMoney () {
            // this.buryPoint(69)
            this.gotopUps()
        },
        gocashOut () {
            localStorage.setItem('cashOutBack', this.$router.history.current.fullPath)
            this.$router.push(
                {
                    path: '/b2b/wallet/myWallet/cashOut'
                    // query: {
                    //     userType: this.userType,
                    //     bindSource: 3
                    // }
                }
            )
        },
        withDraw () {
            // this.buryPoint(71)
            // if (this.userInfo.levelName) {
            //     Toast('活动充值额不可提现')
            //     return
            // }
            if (this.userInfo.companyCode === 'f47596433af5f4e60d7a3a1732407aee') {
                this.$toast('不可进行提现')
                return
            }
            if (this.hasBankcard) {
                if (this.assetsUserInfo.availableBalance < 100) {
                    this.$toast('可用余额小于100元无法提现')
                } else {
                    this.gocashOut()
                }
            } else {
                Dialog.confirm({
                    title: '',
                    message: '尚未成功绑定提现卡，前去银行卡列表'
                }).then(() => {
                    this.gotoBankList()
                }).catch(() => {
                // on cancel
                })
            }
        },
        async getAssetsCenter () {
            await this.getAssetsUserInfoAct({
                companyCode: this.userInfo.companyCode
            })
            await this.getBankcardWithdrawListAct({
                companyCode: this.userInfo.companyCode
            })
            this.hasBankcard = this.bankcardWithdrawList.length > 0
        },
        buryPoint (event) {
            this.setBuried({ event: event })
        }
    },
    mounted () {
        this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
        this.userType = JSON.parse(localStorage.getItem('userType')) || this.$route.query.userType
        this.getAssetsCenter()
    }
}
</script>
<style lang="scss" scoped>
    .assetsPage {
        height: 100%;
        .assetsEchart {
            box-sizing: border-box;
            position: relative;
            text-align: center;
            width: 100%;
            height: 592px;
            padding: 34px 32px;
            line-height: 40px;
            .totalBalance {
                position: absolute;
                left: 50%;
                top: 55%;
                transform: translate(-50%, -50%);
            }
            .echarts {
                width: 100%;
                height: 100%;
            }
        }
        .assetsList {
            padding: 34px 32px;
            .assetsUl {
                .assetsItem {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    .itemText {
                        display: flex;
                        align-items: center;
                        .itemIcon {
                            display: inline-block;
                            width: 16px;
                            height: 16px;
                            border-radius: 50%;
                            margin-right: 12px;
                            &.grayIcon {
                                background-color: #E8E8EA;
                            }
                            &.orgenIcon {
                                background-color: #FF7A45;
                            }
                        }
                    }
                }
            }
            &.mbot48 {
                margin-bottom: 48px;
            }
        }
        .buttonBox {
            display: flex;
            justify-content: space-between;
            padding: 0 32px;
            .buttom {
                flex: 1;
                text-align: center;
                height: 80px;
                line-height: 80px;
                border-radius: 80px;
                border: 2px solid #FF7A45;
                &:last-child {
                    margin-left: 40px;
                }
            }
        }
    }
</style>
